import _ from 'lodash'
import { PagerType } from './constants'

export const getPagers = function (current, offset, totalPage, pagerCount) {
  const pagersPrefix = [{
    type: PagerType.ARROW,
    prev: true,
    value: current - 1,
  }]

  const pagersSuffix = [{
    type: PagerType.ARROW,
    next: true,
    value: current + 1,
  }]
  const pagersMain = []
  let shouldPagersMainLength = pagerCount - 2

  let startPager = current - offset
  if (startPager > 1) {
    pagersPrefix.push({
      type: PagerType.NUMBER,
      value: 1,
    })

    if (startPager > 2) {
      pagersPrefix.push({
        type: PagerType.ELLIPSIS,
        prev: true,
        value: current - (pagerCount - 2),
      })
    }
  } else {
    startPager = 1
    shouldPagersMainLength++
  }

  let endPager = current + offset
  if (endPager < totalPage) { // ... + totalPage
    pagersSuffix.unshift({
      type: PagerType.NUMBER,
      value: totalPage,
    })

    if (endPager < totalPage - 1) {
      pagersSuffix.unshift({
        type: PagerType.ELLIPSIS,
        next: true,
        value: current + (pagerCount - 2),
      })
    }
  } else {
    endPager = totalPage
    shouldPagersMainLength++
  }

  for (let scale = startPager; scale <= endPager; scale++) {
    pagersMain.push({
      type: PagerType.NUMBER,
      value: scale,
    })
  }

  shouldPagersMainLength = Math.min(shouldPagersMainLength, totalPage)

  const diff = shouldPagersMainLength - pagersMain.length
  if (diff > 0) {
    if (pagersMain[0].value === 1) {
      const lastValue = pagersMain[pagersMain.length - 1].value

      for (let i = 1; i <= diff; i++) {
        const pagerValue = lastValue + i
        if (pagerValue >= totalPage) {
          break
        }
        if (pagerValue === totalPage - 1 && pagersSuffix.length === 3) {
          pagersSuffix.shift()
        }

        pagersMain.push({
          type: PagerType.NUMBER,
          value: pagerValue,
        })
      }
    } else if (pagersMain[pagersMain.length - 1].value === totalPage) {
      const firstValue = pagersMain[0].value

      for (let i = 1; i <= diff; i++) {
        const pagerValue = firstValue - i
        if (pagerValue <= 1) {
          break
        }
        if (pagerValue === 2 && pagersPrefix.length === 3) {
          pagersPrefix.pop()
        }

        pagersMain.unshift({
          type: PagerType.NUMBER,
          value: pagerValue,
        })
      }
    }
  }

  return _.concat(pagersPrefix, pagersMain, pagersSuffix)
}
